import { UserEntity } from '../entities';
import { authResource } from './Auth';
export const AccountResource = authResource({
    path: '/accounts/:id',
    schema: UserEntity
});
